'use client'

import { ChevronRight } from 'lucide-react'

import { AppLink } from '@/shared/lib/router'

import { useNavOverflow } from '@/shared/contexts/NavOverflow'
import { Card, CardBody, CardHeader, CardTitle } from '@/shared/ui/Card'
import { Page } from '@/shared/ui/Page'

export function NavigationPage() {
  const { overflowItems } = useNavOverflow()

  return (
    <Page variant="default">
      <Card variant="default" className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>Mais</CardTitle>
        </CardHeader>
        <CardBody>
          <nav
            className="flex flex-col gap-3"
            aria-label="Navegação secundária"
          >
            {overflowItems.map(item => (
              <AppLink
                key={item.href}
                href={item.href}
                className="group flex w-full items-center gap-4 rounded-xl border border-border bg-white p-4 transition-colors hover:border-primary hover:bg-accent"
              >
                <img
                  src={`/icons/${item.iconSlug}.svg`}
                  alt=""
                  className="size-10 shrink-0"
                  aria-hidden
                />
                <span className="flex min-w-0 flex-1 flex-col gap-1">
                  <span className="text-sm font-semibold sm:text-base">
                    {item.title}
                  </span>
                  {item.description && (
                    <span className="text-xs leading-snug text-muted-foreground sm:text-sm">
                      {item.description}
                    </span>
                  )}
                </span>
                <span className="flex shrink-0 items-center gap-1 rounded-full bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground transition-transform group-hover:translate-x-0.5">
                  Acessar
                  <ChevronRight className="size-3.5" aria-hidden />
                </span>
              </AppLink>
            ))}
          </nav>
        </CardBody>
      </Card>
    </Page>
  )
}
